import { z } from '@fiverr-private/forms';
import { translate } from '../translate';
import { SIGN_IN_USERNAME_REGEX } from './constants';
import { emailValidator } from './emailValidator';
import { newPasswordValidator } from './newPasswordValidator';

const isPotentialEmail = (value: string) => value.includes('@');

export const createSignInSchema = () =>
    z.object({
        usernameOrEmail: z.string().refine(
            (value) =>
                isPotentialEmail(value)
                    ? emailValidator().safeParse(value).success
                    : SIGN_IN_USERNAME_REGEX.test(value),
            (value) => ({
                message: isPotentialEmail(value)
                    ? translate('validation.identification_login.format_email')
                    : translate('validation.identification_login.format_username_email'),
            })
        ),
        password: z.string().min(1),
    });

export const createSignUpSchema = () =>
    createSignInSchema().extend({
        password: newPasswordValidator(),
    });

export type SignInFormSchema = z.infer<ReturnType<typeof createSignInSchema>>;
export type SignUpFormSchema = z.infer<ReturnType<typeof createSignUpSchema>>;
